import React from "react";
import withAuth from "./withAuth";

import { IAuthProps } from "./AuthContext";

export interface IToolbarMenuItemProps extends IAuthProps {
    right?: string;
    anyRights?: string[];
    allRights?: string[];
    condition?: boolean;
}

class ToolbarMenuItem extends React.Component<IToolbarMenuItemProps> {
    public render() {
        if (this.props.anyRights && !this.props.anyRights.some(a => this.props.authContext.hasRight(a))) {
            return null;
        }
        if (this.props.allRights && !this.props.allRights.every(a => this.props.authContext.hasRight(a))) {
            return null;
        }
        if ((this.props.condition !== undefined && !this.props.condition) || (this.props.right && !this.props.authContext.hasRight(this.props.right))) {
            return null;
        }

        return this.props.children;
    }
}

export default withAuth(ToolbarMenuItem);
